import { DialogActions, DialogContent, Typography, useMediaQuery, useTheme } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import { memo, ReactElement } from 'react';
import { PmiDialog } from 'shell/components/shared/dialog';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';

interface ExitModalRegCancIdCardProps {
  onConfirm: () => void;
  onClose: () => void;
  open: boolean;
}

const ExitModalRegCancIdCardComponent = ({
  onConfirm,
  onClose,
  open,
}: ExitModalRegCancIdCardProps): ReactElement => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      open={open}
      onClose={onClose}
      aria-labelledby="cancellation-modal-title"
      aria-describedby="cancellation-modal-title"
      fullScreen={fullScreen}
    >
      <PmiDialogTitle id="cancellation-modal-title" backgroundColor="primary" color="white">
        Attenzione!
      </PmiDialogTitle>
      <DialogContent style={{ padding: '30px 24px' }}>
        <Typography>
          Continuando con l&apos;operazione verranno eliminati i dati, si vuole proseguire?
        </Typography>
      </DialogContent>
      <DialogActions>
        <PmiButton id="modalConfirmButton" variant="contained" color="primary" onClick={onConfirm}>
          Conferma annullamento
        </PmiButton>
        <PmiButton
          id="modalCancelButton"
          variant="outlined"
          color="cdmBrand"
          type="button"
          onClick={onClose}
        >
          Chiudi
        </PmiButton>
      </DialogActions>
    </PmiDialog>
  );
};

ExitModalRegCancIdCardComponent.displayName =
  'Exit modal component registration/cancellation id card';

const ExitModalRegCancIdCard = memo(
  ExitModalRegCancIdCardComponent
) as typeof ExitModalRegCancIdCardComponent;

export default ExitModalRegCancIdCard;
